"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Advanced", {
  enumerable: true,
  get: function get() {
    return _Advanced["default"];
  }
});
Object.defineProperty(exports, "ArrowDown", {
  enumerable: true,
  get: function get() {
    return _ArrowDown["default"];
  }
});
Object.defineProperty(exports, "ArrowLeft", {
  enumerable: true,
  get: function get() {
    return _ArrowLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowUpDown", {
  enumerable: true,
  get: function get() {
    return _ArrowUpDown["default"];
  }
});
Object.defineProperty(exports, "Attachment", {
  enumerable: true,
  get: function get() {
    return _Attachment["default"];
  }
});
Object.defineProperty(exports, "Billing", {
  enumerable: true,
  get: function get() {
    return _Billing["default"];
  }
});
Object.defineProperty(exports, "Building", {
  enumerable: true,
  get: function get() {
    return _Building["default"];
  }
});
Object.defineProperty(exports, "Calendar", {
  enumerable: true,
  get: function get() {
    return _Calendar["default"];
  }
});
Object.defineProperty(exports, "Camera", {
  enumerable: true,
  get: function get() {
    return _Camera["default"];
  }
});
Object.defineProperty(exports, "ChatBotOutlined", {
  enumerable: true,
  get: function get() {
    return _ChatBotOutlined["default"];
  }
});
Object.defineProperty(exports, "ChatBotOutlinedV2", {
  enumerable: true,
  get: function get() {
    return _ChatBotOutlinedV["default"];
  }
});
Object.defineProperty(exports, "ChatDuoOutlined", {
  enumerable: true,
  get: function get() {
    return _ChatDuoOutlined["default"];
  }
});
Object.defineProperty(exports, "ChatSingleOutlined", {
  enumerable: true,
  get: function get() {
    return _ChatSingleOutlined["default"];
  }
});
Object.defineProperty(exports, "ChatRectangularDuo", {
  enumerable: true,
  get: function get() {
    return _ChatRectangularDuo["default"];
  }
});
Object.defineProperty(exports, "ChatRectangularSingle", {
  enumerable: true,
  get: function get() {
    return _ChatRectangularSingle["default"];
  }
});
Object.defineProperty(exports, "Channel", {
  enumerable: true,
  get: function get() {
    return _Channel["default"];
  }
});
Object.defineProperty(exports, "Chart", {
  enumerable: true,
  get: function get() {
    return _Chart["default"];
  }
});
Object.defineProperty(exports, "Chat", {
  enumerable: true,
  get: function get() {
    return _Chat["default"];
  }
});
Object.defineProperty(exports, "Check", {
  enumerable: true,
  get: function get() {
    return _Check["default"];
  }
});
Object.defineProperty(exports, "Checkmark", {
  enumerable: true,
  get: function get() {
    return _Checkmark["default"];
  }
});
Object.defineProperty(exports, "ChevronRight", {
  enumerable: true,
  get: function get() {
    return _ChevronRight["default"];
  }
});
Object.defineProperty(exports, "Close", {
  enumerable: true,
  get: function get() {
    return _Close["default"];
  }
});
Object.defineProperty(exports, "CornerDownRight", {
  enumerable: true,
  get: function get() {
    return _CornerDownRight["default"];
  }
});
Object.defineProperty(exports, "Crm", {
  enumerable: true,
  get: function get() {
    return _Crm["default"];
  }
});
Object.defineProperty(exports, "Download", {
  enumerable: true,
  get: function get() {
    return _Download["default"];
  }
});
Object.defineProperty(exports, "Edit", {
  enumerable: true,
  get: function get() {
    return _Edit["default"];
  }
});
Object.defineProperty(exports, "Email", {
  enumerable: true,
  get: function get() {
    return _Email["default"];
  }
});
Object.defineProperty(exports, "EmailClosed", {
  enumerable: true,
  get: function get() {
    return _EmailClosed["default"];
  }
});
Object.defineProperty(exports, "Enter", {
  enumerable: true,
  get: function get() {
    return _Enter["default"];
  }
});
Object.defineProperty(exports, "Error", {
  enumerable: true,
  get: function get() {
    return _Error["default"];
  }
});
Object.defineProperty(exports, "Exclamation", {
  enumerable: true,
  get: function get() {
    return _Exclamation["default"];
  }
});
Object.defineProperty(exports, "Exit", {
  enumerable: true,
  get: function get() {
    return _Exit["default"];
  }
});
Object.defineProperty(exports, "ExternalLink", {
  enumerable: true,
  get: function get() {
    return _ExternalLink["default"];
  }
});
Object.defineProperty(exports, "Eye", {
  enumerable: true,
  get: function get() {
    return _Eye["default"];
  }
});
Object.defineProperty(exports, "EyeOff", {
  enumerable: true,
  get: function get() {
    return _EyeOff["default"];
  }
});
Object.defineProperty(exports, "Flash", {
  enumerable: true,
  get: function get() {
    return _Flash["default"];
  }
});
Object.defineProperty(exports, "Format", {
  enumerable: true,
  get: function get() {
    return _Format["default"];
  }
});
Object.defineProperty(exports, "Forward", {
  enumerable: true,
  get: function get() {
    return _Forward["default"];
  }
});
Object.defineProperty(exports, "Google", {
  enumerable: true,
  get: function get() {
    return _Google["default"];
  }
});
Object.defineProperty(exports, "Grab", {
  enumerable: true,
  get: function get() {
    return _Grab["default"];
  }
});
Object.defineProperty(exports, "Help", {
  enumerable: true,
  get: function get() {
    return _Help["default"];
  }
});
Object.defineProperty(exports, "Inbox", {
  enumerable: true,
  get: function get() {
    return _Inbox["default"];
  }
});
Object.defineProperty(exports, "InboxLayout", {
  enumerable: true,
  get: function get() {
    return _InboxLayout["default"];
  }
});
Object.defineProperty(exports, "Instagram", {
  enumerable: true,
  get: function get() {
    return _Instagram["default"];
  }
});
Object.defineProperty(exports, "InstagramSolid", {
  enumerable: true,
  get: function get() {
    return _InstagramSolid["default"];
  }
});
Object.defineProperty(exports, "Integrations", {
  enumerable: true,
  get: function get() {
    return _Integrations["default"];
  }
});
Object.defineProperty(exports, "Invalid", {
  enumerable: true,
  get: function get() {
    return _Invalid["default"];
  }
});
Object.defineProperty(exports, "KB", {
  enumerable: true,
  get: function get() {
    return _KB["default"];
  }
});
Object.defineProperty(exports, "Label", {
  enumerable: true,
  get: function get() {
    return _Label["default"];
  }
});
Object.defineProperty(exports, "LetterMark", {
  enumerable: true,
  get: function get() {
    return _LetterMark["default"];
  }
});
Object.defineProperty(exports, "LiveChat", {
  enumerable: true,
  get: function get() {
    return _LiveChat["default"];
  }
});
Object.defineProperty(exports, "Mails", {
  enumerable: true,
  get: function get() {
    return _Mails["default"];
  }
});
Object.defineProperty(exports, "Menu", {
  enumerable: true,
  get: function get() {
    return _Menu["default"];
  }
});
Object.defineProperty(exports, "Merge", {
  enumerable: true,
  get: function get() {
    return _Merge["default"];
  }
});
Object.defineProperty(exports, "Messenger", {
  enumerable: true,
  get: function get() {
    return _Messenger["default"];
  }
});
Object.defineProperty(exports, "MessengerSolid", {
  enumerable: true,
  get: function get() {
    return _MessengerSolid["default"];
  }
});
Object.defineProperty(exports, "Minus", {
  enumerable: true,
  get: function get() {
    return _Minus["default"];
  }
});
Object.defineProperty(exports, "MySettings", {
  enumerable: true,
  get: function get() {
    return _MySettings["default"];
  }
});
Object.defineProperty(exports, "Negative", {
  enumerable: true,
  get: function get() {
    return _Negative["default"];
  }
});
Object.defineProperty(exports, "Note", {
  enumerable: true,
  get: function get() {
    return _Note["default"];
  }
});
Object.defineProperty(exports, "OptionsHorizontal", {
  enumerable: true,
  get: function get() {
    return _OptionsHorizontal["default"];
  }
});
Object.defineProperty(exports, "Outlook", {
  enumerable: true,
  get: function get() {
    return _Outlook["default"];
  }
});
Object.defineProperty(exports, "Phone", {
  enumerable: true,
  get: function get() {
    return _Phone["default"];
  }
});
Object.defineProperty(exports, "Pin", {
  enumerable: true,
  get: function get() {
    return _Pin["default"];
  }
});
Object.defineProperty(exports, "Play", {
  enumerable: true,
  get: function get() {
    return _Play["default"];
  }
});
Object.defineProperty(exports, "Plus", {
  enumerable: true,
  get: function get() {
    return _Plus["default"];
  }
});
Object.defineProperty(exports, "PlusAlt", {
  enumerable: true,
  get: function get() {
    return _PlusAlt["default"];
  }
});
Object.defineProperty(exports, "Preferences", {
  enumerable: true,
  get: function get() {
    return _Preferences["default"];
  }
});
Object.defineProperty(exports, "Question", {
  enumerable: true,
  get: function get() {
    return _Question["default"];
  }
});
Object.defineProperty(exports, "Reply", {
  enumerable: true,
  get: function get() {
    return _Reply["default"];
  }
});
Object.defineProperty(exports, "ReplyAll", {
  enumerable: true,
  get: function get() {
    return _ReplyAll["default"];
  }
});
Object.defineProperty(exports, "Reporting", {
  enumerable: true,
  get: function get() {
    return _Reporting["default"];
  }
});
Object.defineProperty(exports, "Reset", {
  enumerable: true,
  get: function get() {
    return _Reset["default"];
  }
});
Object.defineProperty(exports, "Scenery", {
  enumerable: true,
  get: function get() {
    return _Scenery["default"];
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function get() {
    return _Search["default"];
  }
});
Object.defineProperty(exports, "Settings", {
  enumerable: true,
  get: function get() {
    return _Settings["default"];
  }
});
Object.defineProperty(exports, "Shortcuts", {
  enumerable: true,
  get: function get() {
    return _Shortcuts["default"];
  }
});
Object.defineProperty(exports, "WandMagicSparkles", {
  enumerable: true,
  get: function get() {
    return _WandMagicSparkles["default"];
  }
});
Object.defineProperty(exports, "Smiley", {
  enumerable: true,
  get: function get() {
    return _Smiley["default"];
  }
});
Object.defineProperty(exports, "Sms", {
  enumerable: true,
  get: function get() {
    return _Sms["default"];
  }
});
Object.defineProperty(exports, "ThinClose", {
  enumerable: true,
  get: function get() {
    return _ThinClose["default"];
  }
});
Object.defineProperty(exports, "Trash", {
  enumerable: true,
  get: function get() {
    return _Trash["default"];
  }
});
Object.defineProperty(exports, "User", {
  enumerable: true,
  get: function get() {
    return _User["default"];
  }
});
Object.defineProperty(exports, "UserCircle", {
  enumerable: true,
  get: function get() {
    return _UserCircle["default"];
  }
});
Object.defineProperty(exports, "UserGroup", {
  enumerable: true,
  get: function get() {
    return _UserGroup["default"];
  }
});
Object.defineProperty(exports, "Valid", {
  enumerable: true,
  get: function get() {
    return _Valid["default"];
  }
});
Object.defineProperty(exports, "Widget", {
  enumerable: true,
  get: function get() {
    return _Widget["default"];
  }
});
Object.defineProperty(exports, "WindowIcon", {
  enumerable: true,
  get: function get() {
    return _WindowIcon["default"];
  }
});
Object.defineProperty(exports, "OvalLoader", {
  enumerable: true,
  get: function get() {
    return _OvalLoader["default"];
  }
});
Object.defineProperty(exports, "Social", {
  enumerable: true,
  get: function get() {
    return _Social["default"];
  }
});
Object.defineProperty(exports, "Inbox2", {
  enumerable: true,
  get: function get() {
    return _Inbox2["default"];
  }
});
Object.defineProperty(exports, "CheckSquare", {
  enumerable: true,
  get: function get() {
    return _CheckSquare["default"];
  }
});
Object.defineProperty(exports, "FileText", {
  enumerable: true,
  get: function get() {
    return _FileText["default"];
  }
});
Object.defineProperty(exports, "Folder", {
  enumerable: true,
  get: function get() {
    return _Folder["default"];
  }
});
Object.defineProperty(exports, "MailWarning", {
  enumerable: true,
  get: function get() {
    return _MailWarning["default"];
  }
});
Object.defineProperty(exports, "CalendarClock", {
  enumerable: true,
  get: function get() {
    return _CalendarClock["default"];
  }
});
Object.defineProperty(exports, "MailOpen", {
  enumerable: true,
  get: function get() {
    return _MailOpen["default"];
  }
});

var _Advanced = _interopRequireDefault(require("./Advanced"));

var _ArrowDown = _interopRequireDefault(require("./ArrowDown"));

var _ArrowLeft = _interopRequireDefault(require("./ArrowLeft"));

var _ArrowUpDown = _interopRequireDefault(require("./ArrowUpDown"));

var _Attachment = _interopRequireDefault(require("./Attachment"));

var _Billing = _interopRequireDefault(require("./Billing"));

var _Building = _interopRequireDefault(require("./Building"));

var _Calendar = _interopRequireDefault(require("./Calendar"));

var _Camera = _interopRequireDefault(require("./Camera"));

var _ChatBotOutlined = _interopRequireDefault(require("./ChatBotOutlined"));

var _ChatBotOutlinedV = _interopRequireDefault(require("./ChatBotOutlinedV2"));

var _ChatDuoOutlined = _interopRequireDefault(require("./ChatDuoOutlined"));

var _ChatSingleOutlined = _interopRequireDefault(require("./ChatSingleOutlined"));

var _ChatRectangularDuo = _interopRequireDefault(require("./ChatRectangularDuo"));

var _ChatRectangularSingle = _interopRequireDefault(require("./ChatRectangularSingle"));

var _Channel = _interopRequireDefault(require("./Channel"));

var _Chart = _interopRequireDefault(require("./Chart"));

var _Chat = _interopRequireDefault(require("./Chat"));

var _Check = _interopRequireDefault(require("./Check"));

var _Checkmark = _interopRequireDefault(require("./Checkmark"));

var _ChevronRight = _interopRequireDefault(require("./ChevronRight"));

var _Close = _interopRequireDefault(require("./Close"));

var _CornerDownRight = _interopRequireDefault(require("./CornerDownRight"));

var _Crm = _interopRequireDefault(require("./Crm"));

var _Download = _interopRequireDefault(require("./Download"));

var _Edit = _interopRequireDefault(require("./Edit"));

var _Email = _interopRequireDefault(require("./Email"));

var _EmailClosed = _interopRequireDefault(require("./EmailClosed"));

var _Enter = _interopRequireDefault(require("./Enter"));

var _Error = _interopRequireDefault(require("./Error"));

var _Exclamation = _interopRequireDefault(require("./Exclamation"));

var _Exit = _interopRequireDefault(require("./Exit"));

var _ExternalLink = _interopRequireDefault(require("./ExternalLink"));

var _Eye = _interopRequireDefault(require("./Eye"));

var _EyeOff = _interopRequireDefault(require("./EyeOff"));

var _Flash = _interopRequireDefault(require("./Flash"));

var _Format = _interopRequireDefault(require("./Format"));

var _Forward = _interopRequireDefault(require("./Forward"));

var _Google = _interopRequireDefault(require("./Google"));

var _Grab = _interopRequireDefault(require("./Grab"));

var _Help = _interopRequireDefault(require("./Help"));

var _Inbox = _interopRequireDefault(require("./Inbox"));

var _InboxLayout = _interopRequireDefault(require("./InboxLayout"));

var _Instagram = _interopRequireDefault(require("./Instagram"));

var _InstagramSolid = _interopRequireDefault(require("./InstagramSolid"));

var _Integrations = _interopRequireDefault(require("./Integrations"));

var _Invalid = _interopRequireDefault(require("./Invalid"));

var _KB = _interopRequireDefault(require("./KB"));

var _Label = _interopRequireDefault(require("./Label"));

var _LetterMark = _interopRequireDefault(require("./LetterMark"));

var _LiveChat = _interopRequireDefault(require("./LiveChat"));

var _Mails = _interopRequireDefault(require("./Mails"));

var _Menu = _interopRequireDefault(require("./Menu"));

var _Merge = _interopRequireDefault(require("./Merge"));

var _Messenger = _interopRequireDefault(require("./Messenger"));

var _MessengerSolid = _interopRequireDefault(require("./MessengerSolid"));

var _Minus = _interopRequireDefault(require("./Minus"));

var _MySettings = _interopRequireDefault(require("./MySettings"));

var _Negative = _interopRequireDefault(require("./Negative"));

var _Note = _interopRequireDefault(require("./Note"));

var _OptionsHorizontal = _interopRequireDefault(require("./OptionsHorizontal"));

var _Outlook = _interopRequireDefault(require("./Outlook"));

var _Phone = _interopRequireDefault(require("./Phone"));

var _Pin = _interopRequireDefault(require("./Pin"));

var _Play = _interopRequireDefault(require("./Play"));

var _Plus = _interopRequireDefault(require("./Plus"));

var _PlusAlt = _interopRequireDefault(require("./PlusAlt"));

var _Preferences = _interopRequireDefault(require("./Preferences"));

var _Question = _interopRequireDefault(require("./Question"));

var _Reply = _interopRequireDefault(require("./Reply"));

var _ReplyAll = _interopRequireDefault(require("./ReplyAll"));

var _Reporting = _interopRequireDefault(require("./Reporting"));

var _Reset = _interopRequireDefault(require("./Reset"));

var _Scenery = _interopRequireDefault(require("./Scenery"));

var _Search = _interopRequireDefault(require("./Search"));

var _Settings = _interopRequireDefault(require("./Settings"));

var _Shortcuts = _interopRequireDefault(require("./Shortcuts"));

var _WandMagicSparkles = _interopRequireDefault(require("./WandMagicSparkles"));

var _Smiley = _interopRequireDefault(require("./Smiley"));

var _Sms = _interopRequireDefault(require("./Sms"));

var _ThinClose = _interopRequireDefault(require("./ThinClose"));

var _Trash = _interopRequireDefault(require("./Trash"));

var _User = _interopRequireDefault(require("./User"));

var _UserCircle = _interopRequireDefault(require("./UserCircle"));

var _UserGroup = _interopRequireDefault(require("./UserGroup"));

var _Valid = _interopRequireDefault(require("./Valid"));

var _Widget = _interopRequireDefault(require("./Widget"));

var _WindowIcon = _interopRequireDefault(require("./WindowIcon"));

var _OvalLoader = _interopRequireDefault(require("./OvalLoader"));

var _Social = _interopRequireDefault(require("./Social"));

var _Inbox2 = _interopRequireDefault(require("./Inbox2"));

var _CheckSquare = _interopRequireDefault(require("./CheckSquare"));

var _FileText = _interopRequireDefault(require("./FileText"));

var _Folder = _interopRequireDefault(require("./Folder"));

var _MailWarning = _interopRequireDefault(require("./MailWarning"));

var _CalendarClock = _interopRequireDefault(require("./CalendarClock"));

var _MailOpen = _interopRequireDefault(require("./MailOpen"));
//# sourceMappingURL=index.js.map